module.exports = __webpack_public_path__ + "img/senalando-izqdo.png.8f9b37d9.webp";